function loadChat(view) {
    return () => import( /* webpackChunkName: "chat-[request]" */ `../components/Chat/${view}.vue`)
}
const chatRoute = [
    {
        path: '/chat',
        name: 'chat',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadChat('UserList')
    },
    {
        path: '/chat/:userId',
        name: 'inbox',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadChat('InboxMessage')
    },
]

export default chatRoute